interface TextProps{
    text:string,
    className?:any
}


export const Text:React.FC<TextProps>=({text,className})=>{
    return <p className={`text ${className}`}>{text}</p>
}